/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trimbleDiagnosticsControllerListAccountUsers } from "./trimbleDiagnosticsControllerListAccountUsers";
import { trimbleDiagnosticsControllerLookupAccount } from "./trimbleDiagnosticsControllerLookupAccount";
import { trimbleDiagnosticsControllerLookupEmsEntitlement } from "./trimbleDiagnosticsControllerLookupEmsEntitlement";
import { trimbleDiagnosticsControllerLookupInvitesByEmail } from "./trimbleDiagnosticsControllerLookupInvitesByEmail";
import { trimbleDiagnosticsControllerLookupUser } from "./trimbleDiagnosticsControllerLookupUser";
import { trimbleDiagnosticsControllerLookupUserByEmail } from "./trimbleDiagnosticsControllerLookupUserByEmail";

export function trimbleDiagnosticsService() {
  return { trimbleDiagnosticsControllerLookupAccount, trimbleDiagnosticsControllerLookupEmsEntitlement, trimbleDiagnosticsControllerListAccountUsers, trimbleDiagnosticsControllerLookupUserByEmail, trimbleDiagnosticsControllerLookupInvitesByEmail, trimbleDiagnosticsControllerLookupUser }
}